<template>
  <div class="container">
    <!-- 功能 -->
    <div class="table-container">
      <div class="table-action-row">
        <div class="table-action-form">
          <el-input
            class="form-item"
            v-model="sandBoxSearch.name"
            clearable
            placeholder="请输入模版名称"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>

          <el-input
            class="form-item"
            v-model="sandBoxSearch.id"
            clearable
            placeholder="请输入模版id"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>

          <el-input
            class="form-item"
            v-model="sandBoxSearch.update_by"
            clearable
            placeholder="更新人"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>

          <el-date-picker
            class="form-item time_css"
            v-model="sandBoxSearch.update_time"
            type="datetimerange"
            start-placeholder="更新时间"
            end-placeholder="更新时间"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            @change="handleChange"
          ></el-date-picker>

          <el-button @click="handleReset">重 置</el-button>
        </div>
        <div class="table-action-button">
          <el-button
            v-if="jurisdiction.updateManage_sandboxTemplate_create"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
          >
            新建SandBox模版
          </el-button>
          <!-- <el-button type="info" @click="deployVisible = true">模型导入</el-button> -->
        </div>
      </div>
      <List ref="list" :request="getList" :layout="layout">
        <template v-slot:table-action>
          <el-table-column fixed="right" label="操作" width="500">
            <template slot-scope="scope">
              <el-button class="text-button" type="text" @click="toDetail(scope.row)">
                查看详情
              </el-button>
              <el-button
                class="text-button"
                v-if="jurisdiction.updateManage_sandboxTemplate_edit"
                type="text"
                @click="edit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                class="text-button"
                v-if="jurisdiction.updateManage_sandboxTemplate_delete"
                type="text"
                @click="toDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </List>

      <!-- 新建和编辑 -->
      <createSandboxTemplate
        :visible="createVisible"
        @close="createVisible = false"
        :row="rowMessage"
        :operate-type="operateType"
        @refresh="refresh"
      />
      <detailSandbox
        :visible="detailVisible"
        @close="detailVisible = false"
        :row="rowMessage"
        :jurisdiction="jurisdiction"
        @editSandBoxTemplate="editFromDetail"
      />
      <messageBox ref="messageBox" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '@/components/table';
import createSandboxTemplate from './SandboxTemplateCreate.vue';
import detailSandbox from './SandboxTemplateDetail.vue';
import messageBox from '@/components/messageBox';
import _ from 'lodash';
import { timestampToISO, isoToTimestamp, formattedDate } from '../utils/index';
// isoToTimestamp
// formattedDate
export default {
  components: {
    List,
    createSandboxTemplate,
    detailSandbox,
    messageBox,
  },
  data() {
    return {
      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: 'full', value: 'full' },
        { label: 'partial', value: 'partial' },
      ],
      // 搜索表单
      sandBoxSearch: {
        id: '',
        name: '',
        create_by: '',
        update_by: '',
        create_time: '',
        update_time: '',
      },
      layout: [
        { name: 'name', label: '模版名称' },
        // { name: 'desensitize_rule', label: '模版类型' },
        { name: 'id', label: 'id' },
        { name: 'update_by', label: '更新人' },
        { name: 'update_time', label: '更新时间' },
      ],
      // 新建窗口展示
      createVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      operateType: '',
      rowMessage: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'updateManage_sandboxTemplate_create',
        'updateManage_sandboxTemplate_delete',
        'updateManage_sandboxTemplate_edit',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      // jurisdictionObj
      // console.log('%c Line:167 🍷 templatejurisdictionObj', 'color:#33a5ff', jurisdictionObj);
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.loading = true;
  },
  methods: {
    refresh() {
      this.$refs.list.resetPage();
      this.$refs.list.getList();
    },
    // 查看详情
    // toDetail
    toDetail(row) {
      this.rowMessage = row;
      this.detailVisible = true;
    },
    // 获取列表数据
    getList({ pageIndex, pageSize }) {
      // this.sandBoxSearch;
      console.log(
        '%c Line:224 🍰 this.sandBoxSearch',
        'color:#2eafb0',
        this.sandBoxSearch,
        pageSize,
      );
      // this.sandBoxSearch.update_time
      console.log(
        '%c Line:175 🥖 this.sandBoxSearch.update_time',
        'color:#b03734',
        this.sandBoxSearch.update_time,
      );
      const params = {};
      if (this.sandBoxSearch.name) {
        params.name = this.sandBoxSearch.name;
      }
      if (this.sandBoxSearch.id) {
        params.id = this.sandBoxSearch.id;
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      if (this.sandBoxSearch.update_time) {
        // params.update_time = timestampToISO(this.sandBoxSearch.update_time);
        params.update_time_begin = timestampToISO(this.sandBoxSearch.update_time[0]);
        params.update_time_end = timestampToISO(this.sandBoxSearch.update_time[1]);
      }
      return this.$request({
        url: this.$api.getAllSandboxTemplate,
        data: {
          offset: (pageIndex - 1) * pageSize,
          limit: pageSize,
          ...params,
        },
      }).then((res) => {
        // res
        console.log('%c Line:187 🥐 res', 'color:#ea7e5c', res);

        const computedList = res.list.map((item) => {
          return {
            ...item,
            update_time: formattedDate(isoToTimestamp(item.update_time)),
          };
        });
        return {
          list: computedList || [],
          total: Number(res.total_count) || 0,
        };
      });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.sandBoxSearch = {
        id: '',
        name: '',
        create_by: '',
        update_by: '',
        create_time: '',
        update_time: '',
      };
      this.refresh();
    },
    // 增删改
    add() {
      this.operateType = 'add';
      this.createVisible = true;
    },
    edit(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    editFromDetail(row) {
      this.rowMessage = row;
      this.operateType = 'edit';
      this.createVisible = true;
    },
    refreshSandbox(row) {
      this.$request({
        url: this.$api.refreshSandbox,
        data: {
          tenant_id: row.id,
        },
      }).then(() => {
        this.$message({
          message:
            row.sandbox_type === 'development'
              ? '预计在1-5分钟后开始执行刷新任务'
              : '将在明天的上午0-6点执行刷新任务',
          type: 'success',
        });
      });
    },
    toDelete({ id, name }) {
      // id
      console.log('%c Line:187 🍻 id', 'color:#33a5ff', id);
      this.$refs.messageBox.show({
        title: '提示',
        content: `确认删除模板“${name}”吗？`,
        titleIconType: 'warning',
        exitButton: true,
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteSandboxTemplate,
            data: { id },
            cb: () => {
              this.$refs.messageBox.close();
              this.refresh();
            },
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';

.container {
  display: flex;
  flex-direction: column;
}
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
.table-container {
  flex: 1;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
  .table-action-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    .table-action-form {
      flex: 1;
      display: flex;
      flex-flow: wrap;
      .form-item {
        width: 240px;
        margin-right: 18px;
      }
    }
  }
  .text-button {
    margin-right: 15px;
  }
  .danger-action {
    color: #e34d59;
  }
}
.time {
  ::v-deep .el-input__inner {
    padding-left: 30px;
  }
}
.time_css {
  min-width: 410px;
  margin-right: 18px;
  height: 32px;
  ::v-deep .el-input__inner {
    padding-left: 30px;
  }
  ::v-deep .el-range__icon {
    line-height: 24px;
  }
  ::v-deep .el-range-separator {
    line-height: 24px;
  }
  ::v-deep .el-range__close-icon {
    line-height: 24px;
  }
}
::v-deep .el-table .cell {
  // background-color: #e34d59;
  display: -webkit-box; /* 使用弹性盒子布局 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  -webkit-line-clamp: 3; /* 限制为3行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  line-height: 1.5; /* 行高 */
  max-height: 4.5em; /* 最大高度，3行 * 行高 */
}
</style>
